/**
 * Error thrown when there is a validation error
 *
 * i.e.: 401
 */
export class UnauthorizedError extends Error {

  /**
   * Extended from ts base class Error
   *
   * @param message
   */
  constructor(message) {
    super(message);
    this.name = 'UnauthorizedError';
  }
}
